/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum FeatureFlags {
	BlankSignaturePrevention = 'BlankSignaturePrevention',
	CardOnFileCustomerManagement = 'CardOnFileCustomerManagement',
	ChangeSelectionType = 'ChangeSelectionType',
	CognitoPay = 'CognitoPay',
	CognitoPayCardOnFile = 'CognitoPayCardOnFile',
	CognitoPayCosmosPurgeTesting = 'CognitoPayCosmosPurgeTesting',
	CognitoPayExperiment = 'CognitoPayExperiment',
	CognitoPayTaxDocuments = 'CognitoPayTaxDocuments',
	CollectTaxId = 'CollectTaxId',
	CollectTaxIdForExistingUsers = 'CollectTaxIdForExistingUsers',
	CustomerAddressValidation = 'CustomerAddressValidation',
	FullFormGeneration = 'FullFormGeneration',
	LimitedWorkflowLinks = 'LimitedWorkflowLinks',
	LimitedWorkflowEmails = 'LimitedWorkflowEmails',
	TestNewModelConversion = 'TestNewModelConversion',
	GemBoxDocumentMergingStandard = 'GemBoxDocumentMergingStandard',
	GemBoxDocumentMergingCustom = 'GemBoxDocumentMergingCustom',
	GemBoxUseInternalRenderer = 'GemBoxUseInternalRenderer',
	GemBoxProductionValidation = 'GemBoxProductionValidation',
	GemBoxProductionValidationPdf = 'GemBoxProductionValidationPdf',
	AIGeneratedWorkflows = 'AIGeneratedWorkflows',
	ModelBasedValidation = 'ModelBasedValidation',
	Profiling = 'Profiling',
	FormValidator = 'FormValidator',
	ImagesInChoiceFields = 'ImagesInChoiceFields',
	ImprovedFieldPickerTokenLoading = 'ImprovedFieldPickerTokenLoading',
	LinkedLookups = 'LinkedLookups',
	LinkedLookupUserTesting = 'LinkedLookupUserTesting',
	RedirectToSettingsForMissingInformation = 'RedirectToSettingsForMissingInformation',
	SecureLookups = 'SecureLookups',
	TaskReminders = 'TaskReminders',
	TaskRemindersTesting = 'TaskRemindersTesting',
	CognitoPayDisputeReminderTesting = 'CognitoPayDisputeReminderTesting',
	StripeConnectEnhancements = 'StripeConnectEnhancements',
	ExtendedSquareTokenRenewal = 'ExtendedSquareTokenRenewal',
	V2Lookups = 'V2Lookups',
	IndependentTaskViews = 'IndependentTaskViews',
	FriendlyFormNames = 'FriendlyFormNames',
	DownloadDirectFromAzure = 'DownloadDirectFromAzure',
	CreateFormFromSpreadsheet = 'CreateFormFromSpreadsheet',
	PrequeueEmailWebhookMessages = 'PrequeueEmailWebhookMessages',
	AzureWebPubSub = 'AzureWebPubSub',
	WorkflowDiagramInBuilder = 'WorkflowDiagramInBuilder',
	ThirdPartyTaxValidation = 'ThirdPartyTaxValidation',
	NewBillingPipeline = 'NewBillingPipeline',
	InternationalTax = 'InternationalTax',
	CollectEUTax = 'CollectEUTax',
	CollectUKTax = 'CollectUKTax',
	CollectAUTax = 'CollectAUTax',
	CollectCATax = 'CollectCATax',
	FileSync = 'FileSync',
	FormEmailAnalysis = 'FormEmailAnalysis',
	SingleEmailFormEmailThrottle = 'SingleEmailFormEmailThrottle',
	PersonSubmissions = 'PersonSubmissions',
	GoogleAdTracking = 'GoogleAdTracking',
	MicrosoftAdTracking = 'MicrosoftAdTracking',
	FileSyncFolderValidation = 'FileSyncFolderValidation',
	RouteNewBillingPath = 'RouteNewBillingPath',
	EnhancedMfaSecurity = 'EnhancedMfaSecurity',
	SecurityNotifications = 'SecurityNotifications',
	CognitoPayNegativeBalanceEmails = 'CognitoPayNegativeBalanceEmails',
	BlockSpamEmailPattern = 'BlockSpamEmailPattern',
	SharedEmailSpamThrottleTrust = 'SharedEmailSpamThrottleTrust',
	AllowCreateLegacyStripe = 'AllowCreateLegacyStripe',
	EmailReputationAudit = 'EmailReputationAudit',
	EmailReputationEnforcement = 'EmailReputationEnforcement',
	EmailReputationLiveScan = 'EmailReputationLiveScan',
	SkipIndustryOnboarding = 'SkipIndustryOnboarding',
	DocumentSigning = 'DocumentSigning',
	EnrichedOnboardingExperience = 'EnrichedOnboardingExperience',
	AutoOpenFormGeneration = 'AutoOpenFormGeneration',
	FormGenFollowUpQuestions = 'FormGenFollowUpQuestions',
	CognitoPayImprovedDeletion = 'CognitoPayImprovedDeletion',
	ActiveDomainProfiling = 'ActiveDomainProfiling',
	GeneratorMetaTagReporting = 'GeneratorMetaTagReporting',
	ShareFormShareDialog = 'ShareFormShareDialog',
	ShareFormToastLinkOnly = 'ShareFormToastLinkOnly',
	NewFormWalkthrough = 'NewFormWalkthrough',
	CognitoPay1099KReporting = 'CognitoPay1099KReporting',
	OrdersDashboardForAllProviders = 'OrdersDashboardForAllProviders',
	LegacySessionInvalidation = 'LegacySessionInvalidation',
}
